import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheBiopowerVision from "./sections/TheBiopowerVision";
import CoreEnergyPillars from "./sections/CoreEnergyPillars";
import FromSeedToTank from "./sections/FromSeedToTank";
import Biodieselproductionprocess from "./sections/Biodieselproductionprocess";
import TheGreenAdvantage from "./sections/TheGreenAdvantage";
import GlobalImpactMetrics from "./sections/GlobalImpactMetrics";
import JoinTheRevolution from "./sections/JoinTheRevolution";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheBiopowerVision />
      <CoreEnergyPillars />
      <FromSeedToTank />
      <Biodieselproductionprocess />
      <TheGreenAdvantage />
      <GlobalImpactMetrics />
      <JoinTheRevolution />
      <Footer />
    </div>;
}